"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doTrackingRedirect = void 0;
var doTrackingRedirect = function (language, daTrackingPage, defaultTrackingPage, page) {
    var trackedConversion = localStorage.getItem("trackConversion");
    if (!trackedConversion) {
        var trackingLandingPage = language === "da" ? daTrackingPage : defaultTrackingPage;
        trackingLandingPage = process.env.CONVERSION_TRACKING_ENABLED === "true" ? trackingLandingPage : "http://localhost/";
        var accountId = page.props.session.current_account.id;
        var resellerId = page.props.session.current_account.reseller_id;
        localStorage.setItem("trackConversion", "true");
        window.location.href = trackingLandingPage + "?R=" + resellerId + "&A=" + accountId;
    }
    return;
};
exports.doTrackingRedirect = doTrackingRedirect;
